import axios from "axios";

const loginedApi = axios.create({
  baseURL: "https://econsult.reemhospital.com/c2mydrrestreem/v1/c2mdapi/",
  //baseURL: "https://uat.c2mdr.com/c2mydrrestreem/v1/c2mdapi/", //changed for interbranch
  timeout: 15000000, // Set timeout to 15 seconds (in milliseconds)
  // baseURL: "http://localhost:8080/c2mydrrestuat/v1/c2mdapi/",
});

export default loginedApi;


// export const SERVER_API_URL = "http://localhost:8080/c2mydrrestuat/v1/c2mdapi"
//export const SERVER_API_URL ="https://uat.c2mdr.com/c2mydrrestreem/v1/c2mdapi/";
export const SERVER_API_URL ="https://econsult.reemhospital.com/c2mydrrestreem/v1/c2mdapi/";

export const FILEURL = "https://econsult.reemhospital.com/reem/Connect2MyDoctorRequest";
 //export const FILEURL =  "https://www.connect2mydoctor.com/ganga/Connect2MyDoctorRequest";
//export const FILEURL = "https://uat.c2mdr.com/reem/Connect2MyDoctorRequest";


export const c2mdApi = axios.create({
  //baseURL: "https://uat.c2mdr.com/c2mydrrestdemo/v1/c2mdapi/",
  baseURL: "https://econsult.reemhospital.com/c2mydrrestreem/v1/c2mdapi/",
});

export const c2mdApinew = axios.create({
  baseURL: "http://localhost:8082/ROOT/",
});
